import { DateTime } from "luxon";
import i18n from "../../utils/i18n";
import CheckBox from "../CheckBox";

const Meals = ({ lunch, dinner }) => {
  const formatMealDate = (meal) => {
    if (!meal) return null;
    const dateTime = meal instanceof DateTime ? meal : DateTime.fromISO(meal);
    return dateTime.toLocaleString(DateTime.DATE_SHORT);
  };

  return (
    <div className="form-group">
      <CheckBox
        readOnly
        checked={!!lunch}
        label={i18n.t("schedule.shifts.form.lunch")}
      />
      <small> {formatMealDate(lunch)}</small>
      <br />
      <CheckBox
        readOnly
        checked={!!dinner}
        label={i18n.t("schedule.shifts.form.dinner")}
      />
      <small> {formatMealDate(dinner)}</small>
      <span className="help-block">
        {i18n.t("schedule.shifts.form.lunch_dinner_help", {
          lunch_period: "6-15",
          dinner_period: "15-6",
          no_meals_period: "0-6",
          two_meals_hours: "10",
        })}
      </span>
    </div>
  );
};

export default Meals;
